<div class="container-fluid">
  <div class="row">
    <app-display-counts-widget
      [widgetPanelCounts]="widgetPanelCounts"
      [widgetPanel]="{ style: { height: '765px' } }"
      [title]="'Pending Reviews'"
    ></app-display-counts-widget>
  </div>
</div>
